import { HttpClient } from '@adapters/HttpClient';

export interface ShopTeam {
  id: number;
  name: string;
}

export interface ShopOption {
  id: string;
  name: string;
  team?: ShopTeam;
}

export interface GetShopsOptions {
  includeTeam?: boolean;
}

export class ShopsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(options: GetShopsOptions = {}): Promise<ShopOption[]> {
    const params: Record<string, any> = {
      per_page: 100,
    };

    // Incluir relación team si se solicita (para 3PL)
    if (options.includeTeam) {
      params['with[]'] = 'team';
    }

    const raw = await this.httpClient.get<any>('/shops', params);
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    return list.map((shop: any) => ({
      id: String(shop.id),
      name: shop.name,
      team: shop.team ? { id: shop.team.id, name: shop.team.name } : undefined,
    }));
  }

  async getShopsPaginated(params: {
    search?: string;
    page?: number;
    limit?: number;
    includeTeam?: boolean;
  }): Promise<{ shops: ShopOption[]; hasMore: boolean }> {
    try {
      const { search = '', page = 1, limit = 20, includeTeam = false } = params;
      const queryParams: Record<string, any> = {
        page,
        per_page: limit,
      };

      // Incluir relación team si se solicita (para 3PL)
      if (includeTeam) {
        queryParams['with[]'] = 'team';
      }

      // Búsqueda por nombre (parámetro correcto: name, no search)
      if (search) {
        queryParams.name = search;
      }

      const response = await this.httpClient.get<any>('/shops', queryParams);
      const list = Array.isArray(response) ? response : (response.data ?? []);
      const meta = response.meta;

      const shops = list.map((shop: any) => ({
        id: String(shop.id),
        name: shop.name,
        team: shop.team ? { id: shop.team.id, name: shop.team.name } : undefined,
      }));

      // Soporte para meta en snake_case o camelCase (scroll infinito)
      const currentPage = meta?.current_page ?? meta?.currentPage ?? 1;
      const lastPage = meta?.last_page ?? meta?.lastPage ?? 1;
      const hasMore = meta ? currentPage < lastPage : false;

      return { shops, hasMore };
    } catch (error) {
      console.error('Error loading shops:', error);
      return { shops: [], hasMore: false };
    }
  }
}
